import React from "react";
import portalBrandLogo from "../../assets/brand/ecotour-logo-128-optimized.webp";
import portalBrandLogo2x from "../../assets/brand/ecotour-logo-256-optimized.webp";

const PUBLIC_FALLBACK =
  "/assets/img/EcoTour_Odisha_Logo_Files/EcoTour_Odisha_Cut_Logo_1600px.png";

export default function PortalBrandLogo({ alt = "EcoTour Odisha", src, ...props }) {
  const handleError = (event) => {
    const image = event.currentTarget;
    if (image.dataset.fallbackApplied === "true") {
      image.style.visibility = "hidden";
      return;
    }
    image.dataset.fallbackApplied = "true";
    image.removeAttribute("srcset");
    image.src = PUBLIC_FALLBACK;
  };

  return <img srcSet={src ? undefined : `${portalBrandLogo} 128w, ${portalBrandLogo2x} 256w`} sizes={src ? undefined : "128px"} {...props} src={src || portalBrandLogo} alt={alt} onError={handleError} />;
}
